var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.130859C2.24 0.130859 0 2.37086 0 5.13086C0 7.89086 2.24 10.1309 5 10.1309C7.76 10.1309 10 7.89086 10 5.13086C10 2.37086 7.76 0.130859 5 0.130859ZM3.645 7.27586L1.85 5.48086C1.655 5.28586 1.655 4.97086 1.85 4.77586C2.045 4.58086 2.36 4.58086 2.555 4.77586L4 6.21586L7.44 2.77586C7.635 2.58086 7.95 2.58086 8.145 2.77586C8.34 2.97086 8.34 3.28586 8.145 3.48086L4.35 7.27586C4.16 7.47086 3.84 7.47086 3.645 7.27586Z",
    fill: "#A6ADBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/checkGrey.a35a9210c4e734b6490d4452d714f9e4.svg";
export { ForwardRef as ReactComponent };